import { render, staticRenderFns } from "./HRPolicyHandbookByDepartment.vue?vue&type=template&id=48377eaa"
import script from "./HRPolicyHandbookByDepartment.vue?vue&type=script&lang=js"
export * from "./HRPolicyHandbookByDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports